import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { Body, Popup } from '@calendly/ui/components/popup';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
const modalSubHeadingCss = "m1js497a";
const ModalSubHeading = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(modalSubHeadingCss, props.className)} />;
});
const styledFooterCss = "surxr89";
const StyledFooter = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(styledFooterCss, props.className)} />;
});
export const MeetingIntelligenceDeleteModal = ({
  onClose,
  onConfirm,
  handleTrackModal
}) => <Popup onClose={() => {
  onClose();
  handleTrackModal('deleteModalDismiss', {
    action: 'dismissed'
  });
}} title={I18n.t('publisher.account_settings.meeting_intelligence.modal.delete.title')} withCloseButton>
    <Body>
      <ModalSubHeading>
        <BodyText>
          {I18n.t('publisher.account_settings.meeting_intelligence.modal.delete.body_text')}
        </BodyText>
      </ModalSubHeading>
    </Body>
    <StyledFooter>
      <Button decoration="secondary-outline" onClick={() => {
      onClose();
      handleTrackModal('deleteModalDismiss', {
        action: 'cta_dismissed'
      });
    }}>
        {I18n.t('publisher.account_settings.meeting_intelligence.modal.cancel')}
      </Button>
      <Button decoration="danger" onClick={onConfirm}>
        {I18n.t('publisher.account_settings.meeting_intelligence.modal.delete.delete_meeting_data')}
      </Button>
    </StyledFooter>
  </Popup>;

require("./meeting_intelligence_delete_modal.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./meeting_intelligence_delete_modal.js");